module.exports = __webpack_public_path__ + "static/media/add-circle.a5fe85d7.svg";